import { render, staticRenderFns } from "./PoliticsPf.vue?vue&type=template&id=4012bb84&"
import script from "./PoliticsPf.vue?vue&type=script&lang=js&"
export * from "./PoliticsPf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports